import { Dispatch, ReactNode, SetStateAction } from 'react';

import { MakeOptional } from '../../../utils/make-optional';
import { ProposalsInterface } from './proposals';

export type AdInterface = {
  chassiVerificado?: {
    mensagem: string,
    status: boolean
  }
  anunciante: {
    email: string;
    id: number;
    nome: string;
    tipo: number;
  };
  controlesPopUp:
    | {
        anuncioId: number;
        respondido: boolean;
        tipo: string;
        visualizado: boolean;
        id: number;
      }[]
    | null;
  dataAtualizacao: number;
  dataInclusao: number;
  dataPublicacao: number | undefined;
  dataValidade: number | undefined;
  expirado: boolean;
  fotos: {
    id: number;
    ordem: number;
  }[];
  id: number;

  incompleto: boolean;

  jornada: {
    anuncioId: number;
    dataCriacao: number;
    etapa: number;
    id: number;
    produtoId: string;
    usuarioSiteId: number;
  };
  link?: string;
  localizacao?: {
    cidade: {
      id: number;
      nome: string;
    };
    estado: {
      id: string;
      nome: string;
    };
  };
  meuPlano: {
    cupomUtilizado: string | null;
    formaDePagamento: string;
    parcelamento: string;
    plano: {
      id: number;
      nome: string;
      preco: number;
    };
    porcentagemDesconto: number | null;
    valorDesconto: number | null;
    valorPago: number | null;
  };

  pagarAgora: boolean;
  podeRenovar: boolean;

  propostas?: ProposalsInterface[];
  renovavel: boolean;

  status: {
    id: number;
    label: string;
    nome: string;
  };

  texto: string;

  urlCompletarAnuncio: string | null;
  urlPagamento: string | null;
  valorVenda: number;

  veiculo: {
    anoFabricacao: number;
    anoModelo: number;
    cambio: string;
    combustivelNome: string;
    combustivelId: number;
    corNome: string;
    corId: number;
    itensDescricao?: {
      id: number;
      nome: string;
    }[];

    km: number;
    marca: {
      id: number;
      nome: string;
    };
    modelo: {
      id: number;
      nome: string;
    };
    opcionais: {
      categoria: string;
      id: number;
      nome: string;
    }[];
    placa: string;
    portas: number;
    versao: {
      id: number;
      nome: string;
    };
  };
};

export interface AdInterfaceWithFilter extends AdInterface {
  filterName?: string;
  filterText?: string;
}

export type AdInterfaceKeys = keyof AdInterface;

export interface AdContextProviderProps {
  children: ReactNode;
}

export interface AdContextInterface {
  currentAd: AdInterfaceWithFilter;
  loading: boolean;
  openEditView: string | undefined;
  formState: FormReducerState;
  dispatchForm: Dispatch<FormReducerAction>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  valueIsDifferentFromCurrent: boolean;
  setValueIsDifferentFromCurrent(value: boolean): void;
  submitOnModalClick: boolean;
  setSubmitOnModalClick(value: boolean): void;
  modalInfoChassi: boolean,
  setModalInfoChassi: React.Dispatch<React.SetStateAction<boolean>>,
  transition: boolean;
  setTransition(state: boolean): void;
  currentWarningMessage: CurrentWarningMessageInterface | undefined;
  setCurrentWarningMessage(state: CurrentWarningMessageInterface | undefined): void;
  setCumulativeChanges: React.Dispatch<React.SetStateAction<MakeOptional<AdInterface> | undefined>>;
  cumulativeChanges: MakeOptional<AdInterface> | undefined;
  currentTabDepth: number;
  setCurrentTabDepth: Dispatch<SetStateAction<number>>;
}

export interface CurrentWarningMessageInterface {
  title: string;
  body: string;
  redirect?: string;
}

export interface PlanInterface {
  id: number;
  nome: string;
  preco: number;
  validade: number;
}

export enum FormReducerKind {
  SET_PRICE_RULES = 'SET_PRICE_RULES',
  SET_MINIMUM_PHOTOS = 'SET_MINIMUM_PHOTOS',
  INVALIDATE_CACHE = 'INVALIDATE_CACHE',
  SET_MODEL_YEARS = 'SET_MODEL_YEARS',
  INVALIDATE_PRICES_CACHE = 'INVALIDATE_PRICES_CACHE'
}

export interface FormReducerState {
  priceRules?: {
    value: string;
  };
  minimumPhotos?: {
    value: string;
  };
  modelYears?: number[];
}

export interface FormReducerActionPayloadPriceRules {
  value: string;
}

export interface FormReducerActionPayloadMinimumPhotos {
  value: string;
}

export interface FormReducerActionPayloadVersions {
  nome: string;
  id: number;
}

export interface FormReducerAction {
  type: keyof typeof FormReducerKind;
  payload?:
    | FormReducerActionPayloadPriceRules
    | FormReducerActionPayloadMinimumPhotos
    | Array<FormReducerActionPayloadVersions>
    | Array<number>;
}
